import { CustomReportsListRoutePath } from "#src/routes/reports/custom-reports";
import { RoutePath } from "#src/utils/route";

export const CustomReportsDetailRoutePath = CustomReportsListRoutePath.concat(
  new RoutePath<"reportVariant" | "reportId">({
    title: "Custom Report Detail",
    path: "/:reportVariant/:reportId/detail",
  })
);
